<div class="nav__container">
  <div class="nav__logo" routerLink="/"></div>
</div>
